import axios from 'axios'

const apiURL = process.env.REACT_APP_API_URL

/** One of the email templates for a kind of email, shared by every user. */
export interface EmailTemplate {
  emailTemplateId: number
  name: string
  subject: string
  body: string
  /** What a new invoice, or a quote email, starts on. */
  isDefault: boolean
  updatedDate: string | null
  updatedBy: string | null
  /** How many invoices are set to be emailed with it. Always 0 for quote templates. */
  invoiceCount: number
}

export interface EmailTemplateList {
  templates: EmailTemplate[]
  /** Placeholder, e.g. {InvoiceNumber}, to what it becomes. */
  placeholders: Record<string, string>
}

export interface EmailTemplateForm {
  name: string
  subject: string
  body: string
  isDefault: boolean
}

const headers = () => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  return {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  }
}

/** The kinds of email with templates of their own. */
export type EmailTemplateKind = 'Invoice' | 'Quote'

export const getEmailTemplates = async (kind: EmailTemplateKind): Promise<EmailTemplateList> => {
  const response = await axios.get(`https://${apiURL}/EmailTemplate/${kind}`, { headers: headers() })
  return response.data
}

export const createEmailTemplate = async (kind: EmailTemplateKind, form: EmailTemplateForm): Promise<EmailTemplate> => {
  const response = await axios.post(`https://${apiURL}/EmailTemplate/${kind}`, form, { headers: headers() })
  return response.data
}

export const updateEmailTemplate = async (
  kind: EmailTemplateKind,
  id: number,
  form: EmailTemplateForm
): Promise<EmailTemplate> => {
  const response = await axios.put(`https://${apiURL}/EmailTemplate/${kind}/${id}`, form, { headers: headers() })
  return response.data
}

/** Retires it: no longer offered, but invoices already on it keep it. */
export const deleteEmailTemplate = async (kind: EmailTemplateKind, id: number): Promise<void> => {
  await axios.delete(`https://${apiURL}/EmailTemplate/${kind}/${id}`, { headers: headers() })
}
